export { GenericHero } from './generic-hero'
export {
  HeroWithRichText,
  type IHeroWithRichTextProps,
} from './hero-with-rich-text'
export { StoreHero } from './store-hero'
